import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.8 7.2v17.6H12V7.2zm-2.4 0c0-1.3 1-2.4 2.4-2.4H12c1.3 0 2.4 1 2.4 2.4v17.6c0 1.3-1 2.4-2.4 2.4H8.8c-1.3 0-2.4-1-2.4-2.4zm13.6 0v17.6h3.2V7.2zm-2.4 0c0-1.3 1-2.4 2.4-2.4h3.2c1.3 0 2.4 1 2.4 2.4v17.6c0 1.3-1 2.4-2.4 2.4H20c-1.3 0-2.4-1-2.4-2.4z" })
});
export default SvgPauseRegularIcon;
